import { useContext } from "react";
import { AffordabilityToolContext } from "../Contexts/AffordabilityToolContext";

function useAffordabilityToolContext(){
    const context = useContext(AffordabilityToolContext);
    if(!context) throw new Error("useAffordabilityToolContext must be used within the affordability tool context");
    return context;
}

export default useAffordabilityToolContext;